// extracted by mini-css-extract-plugin
module.exports = {"DropdownItem":"DropdownMenu_DropdownItem__1AI3w"};